import { createSlice } from "@reduxjs/toolkit";
import {
  getInventoryItemByInventoryItemId,
  createStockTransferDispatch,
} from "./thunk";
import { fetchStockTransfer, fetchStockTransferById } from "./thunk";

interface StockTransferState {
  inventoryItem: any | null;
  createdDispatch: any | null;
  loading: boolean;
  creating: boolean;
  error: string | null;
  createError: string | null;

  list: any[];
  details: any;
  rowCount: number;
}

const initialState: StockTransferState = {
  inventoryItem: null,
  createdDispatch: null,
  loading: false,
  creating: false,
  error: null,
  createError: null,

  list: [],
  details: {},
  rowCount: 0,
};

const StockTransferSlice = createSlice({
  name: "StockTransfer",
  initialState,
  reducers: {
    clearInventoryItem: (state) => {
      state.inventoryItem = null;
      state.error = null;
    },
    clearCreatedDispatch: (state) => {
      state.createdDispatch = null;
      state.createError = null;
    },
    clearErrors: (state) => {
      state.error = null;
      state.createError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get inventory item by ID
      .addCase(getInventoryItemByInventoryItemId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getInventoryItemByInventoryItemId.fulfilled, (state, action) => {
        state.loading = false;
        state.inventoryItem = action.payload;
        state.error = null;
      })
      .addCase(getInventoryItemByInventoryItemId.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || action.error.message || "Failed to fetch inventory item";
      })
      // Create stock transfer dispatch
      .addCase(createStockTransferDispatch.pending, (state) => {
        state.creating = true;
        state.createError = null;
      })
      .addCase(createStockTransferDispatch.fulfilled, (state, action) => {
        state.creating = false;
        state.createdDispatch = action.payload;
        state.createError = null;
      })
      .addCase(createStockTransferDispatch.rejected, (state, action) => {
        state.creating = false;
        const payload = action.payload as any;
        if (payload && typeof payload === 'object' && payload.message) {
          state.createError = payload.message;
        } else {
          state.createError = (payload as string) || action.error.message || "Failed to create stock transfer dispatch";
        }
      })


      .addCase(fetchStockTransfer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStockTransfer.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchStockTransfer.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch Stock Transfer List";
      })
      .addCase(fetchStockTransferById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStockTransferById.fulfilled, (state, action) => {
        state.loading = false;
        state.details = action.payload;
      })
      .addCase(fetchStockTransferById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch stock transfer details";
      });
  },
});


export const { clearInventoryItem, clearCreatedDispatch, clearErrors } = StockTransferSlice.actions;
export default StockTransferSlice.reducer;

